import {
  Controller,
  Navigation,
  Pagination,
  Thumbs,
  FreeMode,
} from "swiper/modules";
import { SwiperModule } from "swiper/types";
import { useIsMobile } from "./useIsMobile";

const useSwiperProps = (isMobileOverride?: boolean | null) => {
  const detectedIsMobile = useIsMobile(768, true);
  const isLessThan768 =
    typeof isMobileOverride === "boolean" ? isMobileOverride : detectedIsMobile;

  const mobileProps = {
    modules: [FreeMode] as SwiperModule[],
    resistance: false,
    followFinger: true,
    threshold: 2,
    touchRatio: 1,
    freeMode: {
      enabled: true,
      momentum: true,
      sticky: false,
    },
    spaceBetween: 16,
    passiveListeners: true,
  } as const;

  const desktopProps = {
    modules: [Controller, Navigation, Pagination, Thumbs] as SwiperModule[],
    spaceBetween: 24,
  } as const;

  return isLessThan768 ? mobileProps : desktopProps;
};

export default useSwiperProps;
